<template>
  <app-dialog
    v-model="model"
    :title="$t('place.overview_dialog.title')"
    :width="700"
  >
    <dl class="grid gap-6">
      <div>
        <dt class="text-lg font-semibold">
          {{ $t("place.overview_dialog.address_title") }}
        </dt>
        <dd class="flex items-center justify-between gap-4">
          {{ place.address.label }}

          <app-button
            color="dark"
            :href="toGoogleMapsLink(place.address)"
            size="small"
            @click="$analytics.track('place_maps_link_clicked')"
          >
            {{ $t("place.overview_dialog.open_in_maps_label") }}
          </app-button>
        </dd>
      </div>

      <template v-if="activeFacilityItems.length > 0">
        <app-divider />

        <div>
          <dt class="mb-1 text-lg font-semibold">
            {{ $t("place.overview_dialog.facilities_title") }}
          </dt>
          <dd>
            <ul class="flex flex-wrap gap-8">
              <li v-for="item in activeFacilityItems" :key="item.key">
                <app-icon class="mr-1" :icon="item.icon" />
                {{ item.label }}
              </li>
            </ul>
          </dd>
        </div>
      </template>

      <template v-if="place.information">
        <app-divider />

        <div>
          <dt class="mb-1 text-lg font-semibold">
            {{ $t("place.overview_dialog.information_title") }}
          </dt>
          <dd>{{ place.information }}</dd>
        </div>
      </template>
    </dl>
  </app-dialog>
</template>

<script lang="ts" setup>
import type { I18nMessage } from "@pollen/core/model/i18n.model";

import { toGoogleMapsLink } from "#imports";

const properties = defineProps<{
  modelValue?: boolean;
  place: DatabaseTable<"places">;
}>();

const model = useVModel(properties, "modelValue");

const { t } = useI18n();
const facilityItems: {
  label: I18nMessage;
  key: keyof DatabaseCompositeType<"place_facilities">;
  icon: string;
}[] = [
  {
    label: t("place.facilities.wheelchair_accessible"),
    icon: "ph:wheelchair",
    key: "wheelchair_accessible",
  },
  {
    label: t("place.facilities.stairs"),
    icon: "ph:steps",
    key: "stairs",
  },
  {
    label: t("place.facilities.elevator"),
    icon: "ph:elevator",
    key: "elevator",
  },
];

const activeFacilityItems = computed(() =>
  facilityItems.filter((item) => !!properties.place.facilities?.[item.key]),
);

const { $analytics } = useNuxtApp();
</script>
